import React from "react";

function NftListing() {
  return (
    <div
      id="listing"
      className="flex justify-center w-full flex-col gap-4 h-full"
    >
      {false ? (
        <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
          <table className="w-full relative text-sm text-left rtl:text-right text-white/40 dark:text-white/70">
            <thead className="text-xs  text-gray-700 sticky top-0 uppercase bg-gray-50 dark:bg-darkBlue-600 dark:text-gray-400">
              <tr>
                <th scope="col" className="px-6 py-3">
                  Price
                </th>
                <th scope="col" className="px-6 py-3">
                  USD
                </th>
                <th scope="col" className="px-6 py-3">
                  Quantity
                </th>
                <th scope="col" className="px-6 py-3">
                  Price Difference
                </th>
                <th scope="col" className="px-6 py-3">
                  Expiration
                </th>
                <th scope="col" className="px-6 py-3">
                  From
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="bg-white border-b dark:bg-darkBlue-500 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-darkBlue-400">
                <th
                  scope="row"
                  className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                >
                  23.34 ETH
                </th>
                <td className="px-6 py-4">$299</td>
                <td className="px-6 py-4">2</td>
                <td className="px-6 py-4">23% below</td>
                <td className="px-6 py-4">in 10 days</td>
                <td className="px-6 py-4 text-right">
                  <a
                    href=""
                    className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
                  >
                    Kunal23d
                  </a>
                </td>
              </tr>
              <tr className="bg-white border-b dark:bg-darkBlue-500 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-darkBlue-400">
                <th
                  scope="row"
                  className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                >
                  23.34 ETH
                </th>
                <td className="px-6 py-4">$299</td>
                <td className="px-6 py-4">2</td>
                <td className="px-6 py-4">23% below</td>
                <td className="px-6 py-4">in 10 days</td>
                <td className="px-6 py-4 text-right">
                  <a
                    href=""
                    className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
                  >
                    Kunal23d
                  </a>
                </td>
              </tr>
              <tr className="bg-white border-b dark:bg-darkBlue-500 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-darkBlue-400">
                <th
                  scope="row"
                  className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                >
                  23.34 ETH
                </th>
                <td className="px-6 py-4">$299</td>
                <td className="px-6 py-4">2</td>
                <td className="px-6 py-4">23% below</td>
                <td className="px-6 py-4">in 10 days</td>
                <td className="px-6 py-4 text-right">
                  <a
                    href=""
                    className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
                  >
                    Kunal23d
                  </a>
                </td>
              </tr>
              <tr className="bg-white border-b dark:bg-darkBlue-500 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-darkBlue-400">
                <th
                  scope="row"
                  className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                >
                  23.34 ETH
                </th>
                <td className="px-6 py-4">$299</td>
                <td className="px-6 py-4">2</td>
                <td className="px-6 py-4">23% below</td>
                <td className="px-6 py-4">in 10 days</td>
                <td className="px-6 py-4 text-right">
                  <a
                    href=""
                    className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
                  >
                    Kunal23d
                  </a>
                </td>
              </tr>
              <tr className="bg-white border-b dark:bg-darkBlue-500 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-darkBlue-400">
                <th
                  scope="row"
                  className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                >
                  23.34 ETH
                </th>
                <td className="px-6 py-4">$299</td>
                <td className="px-6 py-4">2</td>
                <td className="px-6 py-4">23% below</td>
                <td className="px-6 py-4">in 10 days</td>
                <td className="px-6 py-4 text-right">
                  <a
                    href=""
                    className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
                  >
                    Kunal23d
                  </a>
                </td>
              </tr>
              <tr className="bg-white border-b dark:bg-darkBlue-500 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-darkBlue-400">
                <th
                  scope="row"
                  className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                >
                  23.34 ETH
                </th>
                <td className="px-6 py-4">$299</td>
                <td className="px-6 py-4">2</td>
                <td className="px-6 py-4">23% below</td>
                <td className="px-6 py-4">in 10 days</td>
                <td className="px-6 py-4 text-right">
                  <a
                    href=""
                    className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
                  >
                    Kunal23d
                  </a>
                </td>
              </tr>
              <tr className="bg-white border-b dark:bg-darkBlue-500 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-darkBlue-400">
                <th
                  scope="row"
                  className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                >
                  23.34 ETH
                </th>
                <td className="px-6 py-4">$299</td>
                <td className="px-6 py-4">2</td>
                <td className="px-6 py-4">23% below</td>
                <td className="px-6 py-4">in 10 days</td>
                <td className="px-6 py-4 text-right">
                  <a
                    href=""
                    className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
                  >
                    Kunal23d
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      ) : (
        <div className="flex text-white text-center justify-center w-full flex-col gap-4 h-full">
          Listing is under maintenance
        </div>
      )}
    </div>
  );
}

export default NftListing;
